import { render } from "./ExpiryBoard.vue?vue&type=template&id=3044ca27&scoped=true"
import script from "./ExpiryBoard.vue?vue&type=script&lang=js"
export * from "./ExpiryBoard.vue?vue&type=script&lang=js"

import "./ExpiryBoard.vue?vue&type=style&index=0&id=3044ca27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3044ca27"]])

export default __exports__